import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCubeLeft = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.21526 0H3.94775L3.80519 0.213842C3.80096 0.219898 3.79686 0.226051 3.79289 0.232299L0.0876514 5.79018L0.0797824 5.80198L0 5.92165V6.00001V6.07304V6.07305V13.5038V14.0038H0.5H10.7172H11.0262L11.1644 13.7274L13.9509 8.15433L14.0037 8.04875V7.93072V0.5V0H13.5037H4.21535H4.21526ZM4.75 5.57305V1H12.6947L10.4082 5.57305H4.75ZM4.75 7.43072V6.57305H10.2172V7.81684C10.1657 7.59557 9.96719 7.43072 9.73023 7.43072H7.52424C7.2481 7.43072 7.02424 7.65458 7.02424 7.93072C7.02424 8.20686 7.2481 8.43072 7.52424 8.43072H9.73023C9.96719 8.43072 10.1657 8.26588 10.2172 8.0446V13.0038H1.67926L4.75 8.50001V8.43072H5.31826C5.5944 8.43072 5.81826 8.20686 5.81826 7.93072C5.81826 7.65458 5.5944 7.43072 5.31826 7.43072H4.75ZM11.2172 6.19107L13.0037 2.61804V7.43072H11.9362C11.6601 7.43072 11.4362 7.65458 11.4362 7.93072C11.4362 8.20686 11.6601 8.43072 11.9362 8.43072H12.6947L11.2172 11.3857V6.19107Z",
		fill: "white"
	})]
});
export default SvgCubeLeft;
